// @flow

import { completeRequest, beginRequest } from "@store/utils";
import type { DefaultStandardScriptsState, DefaultStandardScript } from "./types";
import type { Action } from "redux-action";
import type { ApprovableContainer } from "@modules/service/types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetDefaultStandardScriptSuccess = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetDefaultStandardScriptError = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onUpdateDefaultStandardScriptError = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onStartDefaultStandardScriptDraftSuccess = (state: DefaultStandardScriptsState) => (
  action: Action<ApprovableContainer<DefaultStandardScript>>,
) => ({
  ...state,
  draft: (action.payload && action.payload.active) || {},
});

export const onUpdateDefaultStandardScriptDraft = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  draft: payload,
});

export const onToggleEditDefaultStandardScriptModal = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowDisableDefaultStandardScriptModal = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDisableModal: payload,
  },
});

export const onSetShowDiscardDefaultStandardScriptModal = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDiscardModal: payload,
  },
});

export const onSetShowCancelDefaultStandardScriptModal = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelModal: payload,
  },
});

export const onSetShowCancelDiscardDefaultStandardScriptModal = (
  state: DefaultStandardScriptsState,
) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelDiscardModal: payload,
  },
});

export const onSetShowSubmitDefaultStandardScriptModal = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showSubmitModal: payload,
  },
});
